import { lr } from '../leadsraiser/index';
import * as typeUtils from '../misc/typeUtils';
var logExceptionsDisableKey = '__log_exceptions_disable';
function logExceptionsInMethods(target) {
    var excludedMethods = ['constructor'];
    if (target.hasOwnProperty(logExceptionsDisableKey)) {
        excludedMethods.push.apply(excludedMethods, target[logExceptionsDisableKey]);
    }
    for (var propertyName in target) {
        if (target.hasOwnProperty(propertyName)) {
            logExceptionsInMethod(target, propertyName, excludedMethods);
        }
    }
}
function logExceptionsInMethod(target, propertyName, excludedMethods) {
    var method = target[propertyName];
    if (typeUtils.isFunction(method) && excludedMethods.indexOf(propertyName) < 0) {
        target[propertyName] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            try {
                var result = method.apply(this, args);
                if (!typeUtils.isUndefined(result)) {
                    Promise.resolve(result).then(undefined, function (reason) {
                        if (reason instanceof Error) {
                            lr.api.registerException(reason);
                        }
                        else {
                            lr.api.registerError('Promise has been rejected', null, {
                                reason: reason
                            });
                        }
                        return Promise.reject(reason);
                    });
                }
                return result;
            }
            catch (e) {
                lr.api.registerException(e);
                throw e;
            }
        };
    }
}
export function LogExceptionsDisable() {
    return function (target, propertyKey, descriptor) {
        var disabledMethods = [];
        if (target.hasOwnProperty(logExceptionsDisableKey)) {
            disabledMethods = target[logExceptionsDisableKey];
        }
        else {
            target[logExceptionsDisableKey] = disabledMethods;
        }
        disabledMethods.push(propertyKey);
    };
}
export function LogExceptions(logStatic) {
    if (logStatic === void 0) { logStatic = false; }
    return function (target, propertyKey) {
        try {
            if (propertyKey) {
                var excludedMethods = ['constructor'];
                if (target.hasOwnProperty(logExceptionsDisableKey)) {
                    excludedMethods.push.apply(excludedMethods, target[logExceptionsDisableKey]);
                }
                logExceptionsInMethod(target, propertyKey, excludedMethods);
            }
            else {
                logExceptionsInMethods(target.prototype); // instance
                if (logStatic) {
                    logExceptionsInMethods(target); // static
                }
            }
        }
        catch (e) {
            lr.api.registerException(e);
        }
    };
}
//# sourceMappingURL=LogExceptions.js.map


//////////////////
// WEBPACK FOOTER
// ../~/xm-ui/logging/LogExceptions.js
// module id = 51
// module chunks = 1